import axios from "axios";
import apiClient from "./BaseService";

import { EMPLOYEE_URL, URL } from "../config";
import { store } from "../_app";

interface UserLoginProps {
  username: string;
  password: string;
  /** Trusted-device token; when valid the backend skips the OTP step. */
  device_token?: string;
}

interface EmployeeLoginProps {
  email: string;
  password: string;
  /** Trusted-device token; when valid the backend skips the OTP step. */
  device_token?: string;
}

interface OtpVerifyProps {
  email: string;
  otp: string;
  /** Ask the backend to issue a device_token so future logins skip OTP. */
  trust_device?: boolean;
  device_name?: string;
  /** Sent when the login response supplied one (token-based backend variant). */
  verification_token?: string;
}

interface OtpResendProps {
  email: string;
  verification_token?: string;
}

const jsonHeaders = {
  headers: {
    "Content-Type": "application/json",
  },
};

const _userLogin = async (data: UserLoginProps) =>
  axios.post(URL.LOGIN, data, jsonHeaders);

// <------------- OTP (two-step login) ------------->

const _verifyOtp = async (data: OtpVerifyProps) =>
  axios.post(URL.VERIFY_OTP, data, jsonHeaders);

const _resendOtp = async (data: OtpResendProps) =>
  axios.post(URL.RESEND_OTP, data, jsonHeaders);

const _employeeVerifyOtp = async (data: OtpVerifyProps) =>
  axios.post(EMPLOYEE_URL.VERIFY_OTP, data, jsonHeaders);

const _employeeResendOtp = async (data: OtpResendProps) =>
  axios.post(EMPLOYEE_URL.RESEND_OTP, data, jsonHeaders);

// <------------- Trusted devices (JWT authenticated) ------------->

const _getTrustedDevices = async () => apiClient.get(URL.TRUSTED_DEVICES);

const _revokeTrustedDevice = async (id: number | string) =>
  apiClient.delete(`${URL.TRUSTED_DEVICES}${id}/`);

const _refreshToken = async () =>
  axios.post(URL.REFRESH_TOKEN, {
    refresh: store.getState().user.refresh,
  });

const _logoutRegister = async () =>
  axios.patch(URL.LOGOUT_REGISTER + `?user_id=${store.getState().user.id}`);

const _forgotPassword = async (email: string) =>
  axios.post(
    URL.PASSWORD_RESET,
    { email },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

const _validateToken = async (token: string) => {
  let res = axios.get(URL.VALIDATE_TOKEN + token, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return res;
};

const _changePassword = async (token: string, password: string) =>
  axios.post(
    URL.CHANGE_PASSWORD,
    { token, password },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

const _setPassword = async (data: any) =>
  axios.post(URL.PASSWORD_SET, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });

const _changePasswordUser = async (data: any) =>
  apiClient.patch(URL.USER_CHANGE_PASSWORD, data);

const _loginAddRequest = async(data:any) => apiClient.post(URL.GET_EXTERNAL_COMPANY_LISTING,data);
   
const _companyAddRequest = async(query:any) => apiClient.get(URL.GET_COMPANY_NAME +`${query}` )



// <------------- Employee Auth Service ------------->

const _employeeLogin = async (data: EmployeeLoginProps) =>
  axios.post(EMPLOYEE_URL.LOGIN, data, jsonHeaders);

const _employeeRefreshToken = async () =>
  axios.post(EMPLOYEE_URL.REFRESH_TOKEN, {
      refresh: store.getState().user.refresh,
  });


  const _getEmployeePermission = async (companyId: any) =>
    apiClient.get(`${EMPLOYEE_URL.GET_EMPLOYEE_PERMISSION}${companyId}`);

export const AuthService = {
  _userLogin,
  _refreshToken,
  _forgotPassword,
  _changePassword,
  _changePasswordUser,
  _validateToken,
  _setPassword,
  _logoutRegister,
  _loginAddRequest,
  _companyAddRequest,
  _employeeLogin,
  _employeeRefreshToken,
  _getEmployeePermission,
  _verifyOtp,
  _resendOtp,
  _employeeVerifyOtp,
  _employeeResendOtp,
  _getTrustedDevices,
  _revokeTrustedDevice,
};
